
namespace TabAurous.JobWork {

    @Serenity.Decorators.registerClass()
    export class JobWorkItemsSelectGrid extends _Ext.GridBase<JobWorkItemsRow, any> {
        protected getColumnsKey() { return 'JobWork.JobWorkItems'; }
        protected getDialogType() { return <any>JobWorkItemsDialog; }
        protected getIdProperty() { return JobWorkItemsRow.idProperty; }
        protected getInitialTitle() { return null; };
        //protected getLocalTextPrefix() { return JobWorkItemsRow.localTextPrefix; }
       // protected getService() { return JobWorkItemsService.baseUrl; }
        //protected getInsertPermission() { return JobWorkItemsRow.insertPermission; }
        //protected getUpdatePermission() { return JobWorkItemsRow.updatePermission; }
        //protected getDeletePermission() { return JobWorkItemsRow.deletePermission; }
        //protected useViewMode() { return true; } 
      
        constructor(container: JQuery, options) {
            super(container, options); 
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        }

        private autoSize;
 

        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        get selectedItems(): JobWorkItemsRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected usePager() { return false; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };


        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
            //var request = this.view.params;
            //if (this.options.hideProducts && this.options.hideProducts.length)
            //    request.Criteria = Serenity.Criteria.and(request.Criteria, [["ProductID" /* ProductID */], 'not in', [this.options.hideProducts]]);
            return true;

        }

    } 
}